/**
 * User access/refresh tokens in sessionStorage — used when httpOnly cookies are blocked
 * (e.g. site at http://207.180.213.153:3043 → API at https://api.paisacx.io).
 * Backend still sets cookies for same-origin deploys; Bearer is the fallback.
 */

const ACCESS_KEY = "paisacx_user_access_token";
const REFRESH_KEY = "paisacx_user_refresh_token";

export function setUserTokens(access, refresh) {
  if (access) sessionStorage.setItem(ACCESS_KEY, access);
  if (refresh) sessionStorage.setItem(REFRESH_KEY, refresh);
}

export function getUserAccessToken() {
  return sessionStorage.getItem(ACCESS_KEY) || null;
}

export function getUserRefreshToken() {
  return sessionStorage.getItem(REFRESH_KEY) || null;
}

export function clearUserTokens() {
  sessionStorage.removeItem(ACCESS_KEY);
  sessionStorage.removeItem(REFRESH_KEY);
}

export const USER_SESSION_EXPIRED_EVENT = "paisacx:user-session-expired";

/** Fired when a 401 could not be recovered by /auth/refresh — AuthProvider logs the user out. */
export function notifyUserSessionExpired() {
  if (typeof window !== "undefined") {
    window.dispatchEvent(new Event(USER_SESSION_EXPIRED_EVENT));
  }
}
